import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Authenticationservice } from '../../services/authentication.service';
import axios from 'axios';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomService } from '../../services/custom.service';

@Component({
  selector: 'app-docforaskformoney',
  templateUrl: './docforaskformoney.component.html',
  styleUrls: ['./docforaskformoney.component.css']
})
export class DocforaskformoneyComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator,{static:false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static:false}) sort: MatSort;
  
  constructor(private auth:Authenticationservice,private spinner: NgxSpinnerService
    ) {
    const date = new Date()
    const result = date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
    this.time = result;

    let userdata;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;
    this.supname = userdata.supname;
    this.Loadallpromisebyzone();
   }

   time;
  zone;
  supname;
  supcode;
  allpromisebyzone;
  displayaskformoney = ['number','datetime','plat_no','farmername','mngcomment','financialamount','print','cancle'];

  ngOnInit(): void {
  }

  ngAfterViewInit(){
  }


  Filterby(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.allpromisebyzone.filter = filterValue.trim().toLowerCase();;
    if (this.allpromisebyzone.paginator) {
      this.allpromisebyzone.paginator.firstPage();
    }
  }

  Loadallpromisebyzone(){
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfinance6566w?zonePost=%27"+this.zone+"%27&doc_status=%270%27";
    axios.get(url)
    .then(res => {
     this.allpromisebyzone = new MatTableDataSource(res.data.recordset);
     this.paginator.length = res.data.rowsAffected[0];
     this.paginator.pageSize= 10;
      this.allpromisebyzone.sort = this.sort;
      this.allpromisebyzone.paginator = this.paginator;

     console.log(this.allpromisebyzone);
    }).catch(err => { throw(err); })
  }

  dataone:any;
  datafamer:any;
  summoney:any;
  print_doc(fmcode){
    console.log(fmcode)
    this.getratedata(fmcode);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_getfinance6566w?doc_status=0&FMCODE_B1='" + fmcode + "'";
    axios.get(url)
    .then(res => {
    let dataone = res.data.recordset;
    this.dataone = res.data.recordset;
    this.summoney = ((dataone.map(el => { return el.money_amt})).reduce((a, b) => a + b, 0)).toLocaleString();
    }).catch(err => { throw(err); })

    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/getfmdata?fmcode_b1=" + fmcode ;
    axios.get(url2)
    .then(res => {
    this.datafamer = res.data.recordset;
    }).catch(err => { throw(err); })

    setTimeout(() => {
      window.print();
    }, 2500);
  }


  DatetoLocal(thisdate:any){
    const date1 = new Date(thisdate);
    let options:any = {
      // weekday: "short",
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };

    return date1.toLocaleString('th-TH', options);
  }
  
  retadata:any;
  getratedata(fmcode){

    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/v_bt6566farmer_w?FMCODE_B1=%27"+ fmcode +"%27";
    axios.get(url)
    .then(res => {
      this.spinner.show();
    this.retadata = res.data.recordset;
    this.spinner.hide();
    }).catch(err => { throw(err); })

  }

  // ยกเลิกคำขอ
  cancledoc_id(doc_id){

    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_doc_status?docid="+doc_id+"&doc_status=X";

    if (confirm("ต้องการยกเลิกรายการ ?") == true) {
      axios.post(url)
      .then(res => {
        if(res.data.rowsAffected[0] == 1)
        { alert("ยกเลิกรายการแล้วค่ะ"); this.Loadallpromisebyzone(); }
        else 
        {
          alert("!!! ไม่สำเร็จ !!!")
        }
      }).catch(err => { throw(err); })
    } else {
      return false;
    }
  }
}


